// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"680b3b38","529":"680b3b38","910":"680b3b38"}[chunkId] + ".chunk.js";
};